import React, { createContext, useCallback, useContext, useState } from "react"

export interface OpenModalParams {
  code?: string
  runtimeAction?: () => void
  trackingPayload?: { service?: string; backendMessage?: string }
  requestId?: string
  modalDescription?: string
}

export interface ErrorModalContextValue {
  open: boolean
  code?: string
  runtimeAction?: () => void
  trackingPayload?: { service?: string; backendMessage?: string }
  requestId?: string
  modalDescription?: string
  openModal: (params: OpenModalParams) => void
  closeModal: () => void
}

const ErrorModalContext = createContext<ErrorModalContextValue | undefined>(undefined)

// Nuevo capturador de errores para el modal de error

export const ErrorModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState<Omit<ErrorModalContextValue, "openModal" | "closeModal">>({
    open: false,
  })

  const openModal = useCallback((params: OpenModalParams) => {
    setState((prev) => ({ ...prev, open: true, ...params }))
  }, [])

  const closeModal = useCallback(() => {
    setState((prev) => ({ ...prev, open: false }))
  }, [])

  return (
    <ErrorModalContext.Provider value={{ ...state, openModal, closeModal }}>
      {children}
    </ErrorModalContext.Provider>
  )
}

/** Hook para consumir el context. Lanza si se usa fuera de `ErrorModalProvider`. */
export const useErrorModalCtx = (): ErrorModalContextValue => {
  const ctx = useContext(ErrorModalContext)
  if (!ctx) {
    throw new Error("useErrorModalCtx must be used within an ErrorModalProvider")
  }
  return ctx
}
